<div class="modal-header">
        <h4 class="modal-title">{{'view_editorial_details.editors_details'|translate}} </h4>
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">{{'view_editorial_details.close'|translate}}</button>
</div>
<div class="modal-body  ">
    <div class="row">
        <div class="col d-flex justify-content-center">
            <div class="outer-circle">
                <div class="inner-circle">
                  <img class="image-container" src="{{editorsImageUrl}}{{details.image}}">
                </div>
                <div class="small-circle"></div>
              </div>
        </div>
    </div>
    <div class="row  mb-5">
        <div class="col-12 ">
            <div class="outer-circle-wrapper ">
                <div>
                 
                  <div class="editor-details">
                    <div class="justify-content-center">
											<div class="editor-name  pt-2 text-center" [innerHTML]="checkProfesor(details.name)"></div>
											<div class="editor-name  text-center d-flex justify-content-center"  [innerHTML]="checkName(details.name)"></div>
										</div>
                    <div class="d-flex justify-content-center">
                      <p class="editor-description m-0 pt-1 mb-3">{{details.designation}}</p>
                    </div>
                    <div class="text-container ">
                      <div class="mt-2  pl-3 pr-3" [innerHTML]=details.descrption>
                       
                      </div>
                    </div>
                    <div class="d-flex justify-content-center ">
                      <div>
                         <!-- Tooltip for ORCID -->
                    <span *ngIf="details.orcid" [ngbTooltip]="details.orcid" placement="bottom">
                      <img src="assets/logos/orcid_logo.png" class="pl-3 editors-icon" alt="ORCID" (click)="openOrcidLink(details.orcid)">
                    </span>
                    <!-- Tooltip for Phone -->
                    <span *ngIf="details.phone" [ngbTooltip]="details.phone" placement="bottom">
                      <fa-icon [icon]="['fas','phone']" class="pl-3 editors-icon"></fa-icon>
                    </span>
                         <!-- Tooltip for Email -->
                         <span *ngIf="details.email" [ngbTooltip]="details.email" placement="bottom">
                          <!-- <a [href]="'mailto:' + details.email" target="_blank"> -->
                              <fa-icon [icon]="['fas','envelope']"
                                  class="pl-3 editors-icon"></fa-icon>
                          <!-- </a> -->
                      </span>
                      <!-- Tooltip for Website -->
                      <span *ngIf="details.website" [ngbTooltip]="details.website"
                          placement="bottom">
                          <a target="_blank" [href]="ensureHttps(details.website)"> <fa-icon [icon]="['fas','globe']"
                                  class="pl-3 pr-3 editors-icon"></fa-icon></a>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              

        </div>

    </div>

    <!-- <div class="modal-footer ">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
  </div> -->